import React, { ElementRef, forwardRef } from "react"
import { Autorenew } from "../../icons"
import { Button, ButtonProps } from "../Button"

export type RetryButtonProps = ButtonProps

export const RetryButton = forwardRef<
  ElementRef<typeof Button>,
  RetryButtonProps
>(function RetryButton(
  { children, variant = "secondary", size = "sm", className, ...rest },
  ref,
) {
  return (
    <Button
      className={className}
      icon={Autorenew}
      size={size}
      variant={variant}
      {...rest}
      ref={ref}
    >
      {children ?? "Try again"}
    </Button>
  )
})
